import React, { useState, useEffect, useRef } from "react";
import "../styles/technologies.css";
import Title from "./Title";
import { SlideIn } from "../components/SlideIn";
export const Technologies = (props) => {
	const [display, setDisplay] = useState([0][1]);
	const [ix, setix] = useState(0);
	const [active, setActive] = useState(null);
	function alert1(a, id) {
		setDisplay(a);
		setActive(id);
	}

	const prevCountRef = useRef();
	const prevCount = prevCountRef.current;

	useEffect(() => {
		if ((active !== null) === true) {
			prevCountRef.current = active;
			document.getElementById(active).className = "active";
			if (isNaN(prevCount) === false) {
				document.getElementById(prevCount).className = "inactive";
			}
		}
	}, [active]);

	useEffect(() => {
		if (ix < props.text.technologies.length) {
			setDisplay(props.text.technologies[ix][1]);
		}
	}, [ix]);

	useEffect(() => {
		const el = document.getElementsByClassName("Technologies")[0];

		const observ = new IntersectionObserver(
			(x) => {
				x[0].isIntersecting ? animate(observ) : null;
			},
			{ threshold: 0.5 }
		);
		observ.observe(el);
	}, []);

	function animate(observ) {
		observ.disconnect();
		let i = 0;
		const len = props.text.technologies.length;

		var interval = setInterval(() => {
			if ((i === len) === true) {
				setActive(0);
				setix(0);
				window.clearInterval(interval);
			} else {
				// setix((prevCount) => prevCount + 1);
				setActive(i);
				setix(i);
				i++;
				// console.log(ix);
			}
		}, 200);
	}

	return (
		<div id="stack">
			<div className="Stack">
				<Title title={props.text.title} />
				<SlideIn />
			</div>
			<div className="Technologies" style={{ animation: `fadeIn 1s` }}>
				<div className="TechMenu">
					{props.text.technologies.map((x, index) => {
						return (
							<p
								key={x[0]}
								id={index}
								onMouseOver={(e) => {
									alert1(x[1], e.target.id);
								}}
							>
								{x[0]}
							</p>
						);
					})}
				</div>
				<div className="TechDisplay">
					<p>{display}</p>
				</div>
				<div className="Background"></div>
			</div>
		</div>
	);
};



// WEBPACK FOOTER //
// ./src/components/Technologies.js